/* AMES — Rilevanza: mette i risultati in ordine di attinenza alla ricerca.
 *
 * Il problema. Shopify ordina con una rilevanza sua, che pesa il titolo e la
 * descrizione quasi allo stesso modo: chi cerca "martello demolitore" si trova
 * fra i martelli un carrello che nella scheda cita il martello, e le punte e
 * gli scalpelli sparsi in mezzo alle macchine invece che dopo.
 *
 * La regola, in ordine:
 *   1. il titolo e' la ricerca                     ("Trapano" per "trapano")
 *   2. il titolo comincia con la ricerca           ("Trapano Makita M6002")
 *   3. il titolo contiene la ricerca per intero    ("Mini trapano Fervi")
 *   4. il titolo contiene tutte le parole          ("Martello SDS demolitore")
 *   5. il titolo contiene le parole simili         ("demolitori" per "demolitore")
 *   6. il titolo contiene una parte delle parole
 *   7. corrisponde solo il marchio, il tipo o un'etichetta
 *   8. non corrisponde niente di visibile: sta nella descrizione
 * e in fondo, sempre, gli accessori correlati — punte, dischi, ricambi,
 * batterie — a meno che siano loro l'oggetto della ricerca: chi scrive
 * "punta sds" vuole le punte, non i martelli.
 *
 * A parita' di grado si tiene l'ordine che arriva da Shopify: e' comunque
 * un'informazione e serve a non rimescolare a caso.
 *
 * Nessuna dipendenza e nessuna richiesta di rete: lavora sui dati che la
 * scheda prodotto porta gia' con se' (data-product).
 */
(function (root) {
  'use strict';

  /* Parole che non aiutano a distinguere: se restassero, "avvitatore a
     batteria" e "avvitatore" darebbero lo stesso risultato. */
  var VUOTE = {
    a: 1, ad: 1, al: 1, allo: 1, alla: 1, ai: 1, agli: 1, alle: 1, con: 1, coi: 1,
    da: 1, dal: 1, dallo: 1, dalla: 1, dai: 1, dagli: 1, dalle: 1, de: 1, del: 1,
    dello: 1, della: 1, dei: 1, degli: 1, delle: 1, di: 1, e: 1, ed: 1, gli: 1,
    i: 1, il: 1, in: 1, la: 1, le: 1, lo: 1, nel: 1, nella: 1, o: 1, per: 1,
    su: 1, sul: 1, sulla: 1, un: 1, una: 1, uno: 1, the: 1, of: 1, for: 1
  };

  /* Cio' che si compra "insieme a", non "al posto di". E' l'unica lista scritta
     a mano del file: e' il lessico del banco, non si deduce dai dati. Fuori
     restano viti, dadi, tasselli e ancoranti: da AMES la ferramenta e' una
     categoria a se', non l'accessorio di qualcos'altro. */
  var ACCESSORI = [
    'acc', 'accessori', 'accessorio', 'ricambio', 'ricambi', 'consumabile', 'consumabili',
    'corona', 'tazza', 'manico', 'impugnatura', 'sacchetto', 'sacchetti',
    'punta', 'punte', 'inserto', 'inserti', 'bit', 'scalpello', 'scalpelli',
    'disco', 'dischi', 'dischetto', 'lama', 'lame', 'mola', 'mole',
    'fresa', 'frese', 'spazzola', 'spazzole', 'abrasivo', 'abrasivi', 'abrasiva',
    'batteria', 'batterie', 'caricabatteria', 'caricabatterie',
    'filtro', 'filtri', 'olio', 'lubrificante', 'grasso',
    'tubo', 'tubi', 'raccordo', 'raccordi', 'adattatore', 'adattatori',
    'prolunga', 'prolunghe', 'guarnizione', 'guarnizioni',
    'cinghia', 'cinghie', 'catena', 'catene', 'carboncini',
    'custodia', 'valigetta', 'astuccio',
    'ugello', 'ugelli', 'elettrodo', 'elettrodi',
    'cartuccia', 'cartucce', 'ricarica', 'ricariche'
  ];

  var RX_ACC = new RegExp('(^|\\s)(' + ACCESSORI.join('|') + ')(\\s|$)');

  function senzaAccenti(s) {
    s = String(s == null ? '' : s);
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }

  function norm(s) {
    return senzaAccenti(s)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Con uno spazio davanti e dietro, indexOf diventa una ricerca di parola
     intera: senza, "scala" troverebbe "scalatore" e "scalpello". */
  function bordato(s) { return ' ' + s + ' '; }

  function parole(s) {
    var out = [], w = norm(s).split(' '), i;
    for (i = 0; i < w.length; i++) {
      if (w[i].length >= 2 && !VUOTE[w[i]]) out.push(w[i]);
    }
    return out;
  }

  /* Radice povera ma sufficiente per l'italiano del catalogo: serve solo a far
     incontrare singolare e plurale, maschile e femminile.
       martello/martelli -> martell   disco/dischi -> disc
       punta/punte -> punt            sega/seghe -> seg
     Sotto le cinque lettere non si taglia: "vite" diventerebbe "vit" e
     incontrerebbe "vita". */
  function radice(w) {
    if (w.length <= 4) return w;
    return w.replace(/(ghi|ghe|hi|he|i|e|o|a)$/, '');
  }

  function radici(ws) {
    var out = [], i;
    for (i = 0; i < ws.length; i++) out.push(radice(ws[i]));
    return out;
  }

  /* Due parole si somigliano se una comincia con l'altra E sono lunghe quasi
     uguali. La seconda meta' della regola non c'era, e costava caro: cercando
     "tagliasfalto" un "Tassello con Vite a Taglio Combinato" entrava fra i
     risultati forti, perche' "tagliasfalto" comincia per "tagli". Nelle parole
     composte italiane — tagliasfalto, tagliaerba, portautensili — il primo
     pezzo e' un verbo generico che sta in centinaia di prodotti diversi: da
     solo non dice niente.

     Tre lettere di scarto bastano per singolare/plurale e maschile/femminile,
     che e' tutto quello che questa somiglianza deve coprire:
       demolitor / demolitori   scarp / scarpa   antinfortunistic / -he
     e non abbastanza per far passare tagli / tagliasfalto. */
  function somigliano(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    var lungo = a.length >= b.length ? a : b;
    var corto = a.length >= b.length ? b : a;
    if (corto.length < 4) return false;
    if (lungo.length - corto.length > 3) return false;
    return lungo.indexOf(corto) === 0;
  }

  /* Prima parola vera del titolo: si saltano i codici articolo, che nei
     cataloghi dei fornitori aprono meta' dei nomi ("B-46492 Punta SDS Plus",
     "DT9502-QZ Punta"). Un codice non dice niente su cosa sia il prodotto. */
  function testa(titolo) {
    var w = parole(titolo), i;
    for (i = 0; i < w.length; i++) {
      if (w[i].length >= 3 && !/[0-9]/.test(w[i])) return w[i];
    }
    return w.length ? w[0] : '';
  }

  /* ── Il prodotto e' un accessorio? ───────────────────────────────────────
     Conta la prima parola, non una qualsiasi: "Avvitatore a batteria con
     inserti" e' un avvitatore, "Punta SDS Plus" e' una punta. Cercare la
     parola ovunque seppellirebbe le macchine che nominano il proprio corredo,
     che sono tante.

     Vale anche per il tipo, e li' e' ancora piu' importante: nel catalogo
     esiste "Macchine Utensili e Accessori", che e' il nome di un reparto, non
     di un accessorio. Cercando "accessori" dentro tutta la stringa, le
     smerigliatrici da banco Fervi finivano in coda insieme ai dischi.
     "Dischi per smerigliatrice" comincia invece con "dischi", e li' e' giusto. */
  function accessorio(p) {
    var tipo = p.type || p.tipo || '';
    if (tipo && RX_ACC.test(bordato(testa(tipo)))) return true;
    return RX_ACC.test(bordato(testa(p.title || p.titolo || '')));
  }

  /* La salvaguardia: se il titolo comincia con la cosa cercata, quel prodotto
     e' la cosa cercata e non va in coda, qualunque cosa dica il tipo. Chi
     cerca "smerigliatrice" deve trovare le smerigliatrici, punto. */
  function eProprioQuello(q, p) {
    var qt = parole(q);
    if (!qt.length) return false;
    var tt = testa(p.title || p.titolo || '');
    if (!tt) return false;
    return radice(tt) === radice(qt[0]);
  }

  /* Se la ricerca nomina un accessorio, gli accessori sono il risultato e non
     la coda: "punta sds", "disco diamantato", "batteria makita".
     Conta solo la prima parola, cioe' l'oggetto della ricerca. In "avvitatore
     a batteria" la batteria e' un requisito dell'avvitatore: se bastasse una
     parola qualsiasi, quella ricerca aprirebbe su celle e caricabatterie. */
  function cercaAccessori(q) {
    var qt = parole(q);
    return qt.length > 0 && RX_ACC.test(bordato(qt[0]));
  }

  /* ── Il punteggio ───────────────────────────────────────────────────────── */
  function punteggio(q, p) {
    var qn = norm(q);
    if (!qn) return 0;

    var titolo = norm(p.title || p.titolo || '');
    var tb = bordato(titolo);
    var qb = bordato(qn);

    var qt = parole(qn);
    if (!qt.length) return 0;
    var tt = parole(titolo);

    /* 1-3: la ricerca intera, dentro il titolo */
    if (titolo === qn) return 1000;
    if (tb.indexOf(qb) === 0) return 900;
    if (tb.indexOf(qb) !== -1) return 800;

    /* 4-6: quante parole della ricerca compaiono nel titolo, e in che modo */
    var qr = radici(qt), tr = radici(tt);
    var esatte = 0, simili = 0, i, j, trovata;
    for (i = 0; i < qt.length; i++) {
      trovata = tb.indexOf(bordato(qt[i])) !== -1;
      if (trovata) { esatte++; continue; }
      for (j = 0; j < tr.length; j++) {
        if (somigliano(qr[i], tr[j]) || somigliano(qr[i], tt[j])) { simili++; break; }
      }
    }

    if (esatte === qt.length) {
      /* tutte le parole, alla lettera. Vale di piu' se la prima parola della
         ricerca apre anche il titolo: li' e' l'oggetto, non un dettaglio. */
      return tt[0] === qt[0] ? 700 : 650;
    }
    if (esatte + simili === qt.length) return 560;
    if (esatte + simili > 0) {
      /* proporzionale: due parole su tre valgono piu' di una su tre */
      return 300 + Math.round(160 * (esatte + simili * 0.6) / qt.length);
    }

    /* 6b: un'etichetta uguale a tutta la ricerca.
       Nel catalogo la stessa macchina ha nomi diversi per fornitore —
       tagliasfalto, tagliasuolo, tagliagiunti, sega per pavimentazioni sono
       la stessa cosa — e i nomi equivalenti sono scritti come etichette sui
       prodotti (famiglie_tag.py). Un'etichetta messa a mano che coincide con
       la domanda non e' un indizio debole: e' qualcuno che ha deciso che quel
       prodotto e' cio' che si sta cercando. Vale quanto tutte le parole
       trovate nel titolo. */
    var etichette = (p.tags && p.tags.join) ? p.tags : [];
    for (i = 0; i < etichette.length; i++) {
      if (norm(etichette[i]) === qn) return 700;
    }

    /* 7: non il titolo, ma il marchio, il tipo o un'altra etichetta */
    var altro = bordato(norm(
      (p.brand || p.vendor || '') + ' ' + (p.type || '') + ' ' +
      ((p.tags && p.tags.join) ? p.tags.join(' ') : (p.tags || ''))
    ));
    for (i = 0; i < qt.length; i++) {
      if (altro.indexOf(bordato(qt[i])) !== -1) return 200;
    }

    /* 8: corrisponde solo la descrizione — Shopify l'ha trovato, noi no */
    return 50;
  }

  /* A parita' di punteggio conta dove cade la parola cercata: piu' e' vicina
     all'inizio del titolo, piu' e' l'oggetto della scheda e non un dettaglio.
     Senza questo, per "punta sds" un barattolo di viti "con punta SDS Plus"
     sta insieme alle punte vere, perche' entrambi contengono la ricerca. */
  function posizione(q, p) {
    var titolo = bordato(norm(p.title || p.titolo || ''));
    var qt = parole(q);
    if (!qt.length) return 999;
    var i = titolo.indexOf(bordato(norm(q)));
    if (i === -1) i = titolo.indexOf(bordato(qt[0]));
    return i === -1 ? 999 : i;
  }

  /* Tre fasce, in quest'ordine:
       0  i risultati veri
       1  gli accessori correlati
       2  quelli che non corrispondono a niente di visibile

     La terza fascia e' nuova ed e' la piu' importante delle tre. Quando una
     ricerca ha pochi risultati veri, Shopify allarga da solo: "tagliasfalto"
     restituisce 176 prodotti mentre nel catalogo ce n'e' uno solo con quella
     parola nel titolo. Gli altri 175 non contengono la parola da nessuna
     parte — ne' titolo, ne' tipo, ne' marchio, ne' etichette — e arrivavano
     in cima perche' erano tutti a pari punteggio e decideva l'ordine di
     Shopify: sopra il tagliasfalto vero comparivano i trabattelli.

     Ora finiscono in fondo, sotto una riga che dice cosa sono. Non si buttano:
     ogni tanto la parola cercata sta davvero solo nella descrizione, e chi ha
     scorso fino in fondo la sta cercando li'. */
  function confronta(coda) {
    return function (a, b) {
      if (a._acc !== b._acc) return a._acc - b._acc;
      if (a._pt !== b._pt) return b._pt - a._pt;
      if (a._ps !== b._ps) return a._ps - b._ps;
      return a._i - b._i;
    };
  }

  /* items: array qualsiasi. dati(x) deve restituire {title, type, brand, tags}. */
  function ordina(q, items, dati) {
    var coda = !cercaAccessori(q), i, d, marcati = [], out = [];
    for (i = 0; i < items.length; i++) {
      d = (dati ? dati(items[i]) : items[i]) || {};
      var pt = punteggio(q, d);
      marcati.push({
        v: items[i], _i: i,
        _pt: pt,
        _ps: posizione(q, d),
        _acc: pt <= 50 ? 2
            : ((coda && !eProprioQuello(q, d) && accessorio(d)) ? 1 : 0)
      });
    }
    marcati.sort(confronta(coda));
    for (i = 0; i < marcati.length; i++) out.push(marcati[i].v);
    return out;
  }

  /* Come sopra ma restituisce il grado: serve alle etichette di sezione
     ("Corrispondenza esatta", "Accessori correlati") e ai collaudi. */
  function fascia(q, d) {
    if (punteggio(q, d) <= 50) return 2;
    if (!cercaAccessori(q) && !eProprioQuello(q, d) && accessorio(d)) return 1;
    return 0;
  }

  function grado(q, d) {
    var p0 = punteggio(q, d);
    if (p0 <= 50) return 'descrizione';
    if (!cercaAccessori(q) && !eProprioQuello(q, d) && accessorio(d)) return 'accessorio';
    var pt = p0;
    if (pt >= 800) return 'esatto';
    if (pt >= 560) return 'forte';
    if (pt >= 300) return 'simile';
    if (pt >= 200) return 'marchio';
    return 'descrizione';
  }

  /* ── La griglia dei risultati ────────────────────────────────────────────
     Le schede portano gia' i dati addosso (data-product): non serve altro
     che leggerli, riordinare i nodi e rimetterli. Nessuna richiesta di rete,
     nessun ridisegno delle immagini: si spostano gli elementi, non i pixel. */

  function datiScheda(card) {
    var host = card.matches && card.matches('[data-product]')
      ? card : (card.querySelector ? card.querySelector('[data-product]') : null);
    if (host) {
      try { return JSON.parse(host.getAttribute('data-product')); } catch (e) {}
    }
    var h = card.querySelector && card.querySelector('.pcard__title');
    return { title: h ? h.textContent : (card.textContent || '') };
  }

  /* La riga che separa gli accessori dal resto. Senza, l'ordine c'e' ma non si
     vede, e a meta' pagina sembra solo che i risultati peggiorino. */
  function separatore(testo) {
    var d = document.createElement('div');
    d.className = 'ames-rilev__sep';
    d.setAttribute('role', 'presentation');
    d.innerHTML = '<span></span>';
    d.firstChild.textContent = testo;
    return d;
  }

  function applicaGriglia(griglia, q, etichetta) {
    if (!griglia) return 0;
    q = q || griglia.getAttribute('data-rilevanza') || '';
    if (!q.trim()) return 0;

    var vecchi = griglia.querySelectorAll('.ames-rilev__sep'), i;
    for (i = 0; i < vecchi.length; i++) vecchi[i].remove();

    var schede = [].slice.call(griglia.children);
    if (schede.length < 2) return 0;

    /* Il payload si legge una volta sola: su 48 schede sono 48 JSON.parse,
       non 96. */
    var cache = new Map();
    for (i = 0; i < schede.length; i++) cache.set(schede[i], datiScheda(schede[i]));

    var ordinate = ordina(q, schede, function (c) { return cache.get(c); });

    var frammento = document.createDocumentFragment();
    var etichette = [null, etichetta,
                     (root.AMES_RILEV_T && root.AMES_RILEV_T.descrizione) || ''];
    var fasciaPrec = 0;
    for (i = 0; i < ordinate.length; i++) {
      var f = fascia(q, cache.get(ordinate[i]));
      if (f !== fasciaPrec && i > 0 && etichette[f]) {
        frammento.appendChild(separatore(etichette[f]));
      }
      fasciaPrec = f;
      frammento.appendChild(ordinate[i]);
    }
    griglia.appendChild(frammento);
    return ordinate.length;
  }

  /* ── Quando il catalogo ha un altro nome per la stessa cosa ───────────────
     Cercando "tagliasfalto" il negozio risponde 176 risultati, ma nel catalogo
     c'e' un solo prodotto con quella parola nel titolo: le macchine da taglio
     dell'asfalto stanno sotto Tagliagiunti (Barikell), Tagliasuolo (Sea
     Technology), Sega per pavimentazioni (Breaker), Troncatrice (Breaker).
     Non sono prodotti che mancano: sono prodotti che si chiamano in un altro
     modo, e chi cerca non ha modo di saperlo.

     Quando i risultati veri sono pochi, si dice come li chiama il catalogo.
     L'elenco sta in assets/ames-famiglie.json ed e' scritto a mano, misurato
     voce per voce: e' lessico del banco, non si deduce dai dati. */

  function fasciaFamiglie(griglia, q, veri) {
    if (veri >= 6) return;                       /* il catalogo risponde bene */
    var url = root.__AMES_FAM_URL ||
              (((root.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'assets/ames-famiglie.json');
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var fam = d && d.famiglie && d.famiglie[norm(q)];
        if (!fam || !fam.termini || !fam.termini.length) return;
        var r0 = (root.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var box = document.createElement('div');
        box.className = 'ames-fam';
        var h = document.createElement('p');
        h.className = 'ames-fam__lab';
        h.textContent = fam.titolo || '';
        box.appendChild(h);
        var riga = document.createElement('div');
        riga.className = 'ames-fam__voci';
        fam.termini.forEach(function (t) {
          var a = document.createElement('a');
          a.className = 'ames-fam__v';
          a.href = (r0 + 'search?q=' + encodeURIComponent(t) + '&type=product').replace('//', '/');
          a.textContent = t;
          riga.appendChild(a);
        });
        box.appendChild(riga);
        griglia.parentNode.insertBefore(box, griglia);
      })
      .catch(function () {});
  }

  function avvia() {
    var griglia = document.querySelector('[data-products-grid][data-rilevanza]');
    if (!griglia) return;
    var q = griglia.getAttribute('data-rilevanza') || '';
    applicaGriglia(griglia, null, (root.AMES_RILEV_T && root.AMES_RILEV_T.accessori) || '');
    if (!q.trim()) return;
    var veri = 0;
    [].slice.call(griglia.children).forEach(function (c) {
      if (c.classList.contains('ames-rilev__sep')) return;
      if (fascia(q, datiScheda(c)) === 0) veri++;
    });
    fasciaFamiglie(griglia, q, veri);
  }

  root.AMES_RILEVANZA = {
    norm: norm, parole: parole, radice: radice, posizione: posizione,
    punteggio: punteggio, accessorio: accessorio, cercaAccessori: cercaAccessori,
    eProprioQuello: eProprioQuello,
    ordina: ordina, grado: grado, fascia: fascia, somigliano: somigliano,
    datiScheda: datiScheda, applicaGriglia: applicaGriglia
  };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
    else avvia();
  }
})(typeof window !== 'undefined' ? window : globalThis);

if (typeof module !== 'undefined' && module.exports) module.exports = globalThis.AMES_RILEVANZA;
